import React, { useContext } from "react";
import * as FaIcons from "react-icons/fa";

import InterestContext from "../../context/interest/interestContext";

const ProgressCircles = () => {
  const interestContext = useContext(InterestContext);
  const { formLevel, preSelected } = interestContext;
  return (
  <></>
  )
};

export default ProgressCircles;
